import supabase from "./supabase";

interface CreateAssessmentParams {
  type: string;
  assessment_json: unknown;
  assessment_id: string;
}

export async function createAssessment(data: CreateAssessmentParams): Promise<{
  error: string | null;
}> {
  try {
    const { error } = await supabase.functions.invoke("createAssessment", {
      body: data,
    });

    if (error) {
      console.error("Error creating assesment:", error);
      return { error: error.message };
    }

    return { error: null };
  } catch (err: any) {
    console.error("Error creating assesment:", err);
    return { error: err.message };
  }
}

export async function fetchCustomQuizzes(userId: string) {
  try {
    const { data, error } = await supabase
      .from("assessments")
      .select("*")
      .eq("user_id", userId)
      .eq("type", "quiz");
    return { data, error };
  } catch (err: any) {
    console.error("Error fetching custom quizzes:", err);
    return { data: null, error: err.message || "Unknown error" };
  }
}

export async function fetchCustomMidterms(userId: string) {
  try {
    const { data, error } = await supabase
      .from("assessments")
      .select("*")
      .eq("user_id", userId)
      .eq("type", "midterm");
    return { data, error };
  } catch (err: any) {
    console.error("Error fetching custom midterms:", err);
    return { data: null, error: err.message || "Unknown error" };
  }
}

export async function fetchCustomFinals(userId: string) {
  try {
    const { data, error } = await supabase
      .from("assessments")
      .select("*")
      .eq("user_id", userId)
      .eq("type", "final");
    return { data, error };
  } catch (err: any) {
    console.error("Error fetching custom finals:", err);
    return { data: null, error: err.message || "Unknown error" };
  }
}

export async function fetchCustomProjects(userId: string) {
  try {
    const { data, error } = await supabase
      .from("assessments")
      .select("*")
      .eq("user_id", userId)
      .eq("type", "project");
    return { data, error };
  } catch (err: any) {
    console.error("Error fetching custom projects:", err);
    return { data: null, error: err.message || "Unknown error" };
  }
}

export async function fetchAssessmentById(assessmentId: string) {
  try {
    const { data, error } = await supabase
      .from("assessments")
      .select("*")
      .eq("assessment_id", assessmentId)
      .maybeSingle();
    return { data, error };
  } catch (err: any) {
    console.error("Error fetching assessment by id:", err);
    return { data: null, error: err.message || "Unknown error" };
  }
}

export async function deleteAssessmentById(assessmentId: string) {
  try {
    const { error } = await supabase
      .from("assessments")
      .delete()
      .eq("assessment_id", assessmentId);

    return { error };
  } catch (err: any) {
    console.error("Error deleting assessment by id:", err);
    return { error: err.message || "Unknown error" };
  }
}
